import { combineReducers } from "redux"
import authReducer from "./authSlice"
import uiReducer from "./uiSlice"

export default combineReducers({
  auth: authReducer,
  ui: uiReducer
})